import { getRequest, postRequest, getcontractIdNumber, getWorkorderID } from './api'
import { API_URL_INVENTORY } from '../constants/index'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('ContractID'))
    searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`
  return getRequest(
    `${API_URL_INVENTORY}inventoryClassCostType/get-list/${parseInt(size, 10) || 15}/${parseInt(index, 10) || 0}/${searchTerm ||
      '%20'}/${orderBy || '%20'}`,
  )
}

export async function getCosts(classID) {
  const contractID = getcontractIdNumber()
  const workOrderID = getWorkorderID()
  return getRequest(
    `${API_URL_INVENTORY}inventoryClassCostType/costs/${contractID}/${workOrderID}/${classID}`,
  )
}

export async function find(id) {
  return getRequest(`${API_URL_INVENTORY}inventoryClassCostType/edit/${id}`)
}

// Project setting "ELIN time period from CLIN": { locked, contractYearID, message }
export async function clinPeriod(costTypeID) {
  return getRequest(
    `${API_URL_INVENTORY}inventoryClassCostType/clin-period/${getcontractIdNumber()}/${parseInt(costTypeID, 10) || 0}`,
  )
}

export async function save(values) {
  return postRequest(`${API_URL_INVENTORY}inventoryClassCostType/save`, values)
}

export function remove(values) {
  return postRequest(`${API_URL_INVENTORY}inventoryClassCostType/delete`, values)
}

export async function list2(
  size,
  index,
  searchTerm,
  orderBy,
  inventoryClassCode,
  costTypeCode,
  definitionCode,
  appropriation,
  code,
  isActive,
) {
  const url = new URL(`${API_URL_INVENTORY}inventoryClassCostType/get-list2`)
  const searchParams = new URLSearchParams()

  const contractID = getcontractIdNumber()

  if (contractID !== 0) {
    searchParams.append('contractID', contractID)
  }

  if (size !== null && size !== undefined) {
    searchParams.append('size', parseInt(size, 10) || 15)
  }

  if (index !== null && index !== undefined) {
    searchParams.append('index', parseInt(index, 10) || 0)
  }

  if (searchTerm !== null && searchTerm !== undefined) {
    searchParams.append('searchTerm', searchTerm)
  }

  if (orderBy !== null && orderBy !== undefined) {
    searchParams.append('orderBy', orderBy)
  }

  if (inventoryClassCode !== null && inventoryClassCode !== undefined) {
    searchParams.append('inventoryClassCode', inventoryClassCode)
  }

  if (costTypeCode !== null && costTypeCode !== undefined) {
    searchParams.append('costTypeCode', costTypeCode)
  }

  if (definitionCode !== null && definitionCode !== undefined) {
    searchParams.append('definitionCode', definitionCode)
  }

  if (appropriation !== null && appropriation !== undefined) {
    searchParams.append('appropriation', appropriation)
  }

  if (code !== null && code !== undefined) {
    searchParams.append('code', code)
  }

  if (isActive !== null && isActive !== undefined) {
    searchParams.append('isActive', isActive)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function importData(values) {
  console.log('importData', values)
  const headers = {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
  }
  return postRequest(`${API_URL_INVENTORY}inventoryClassCostType/import`, values, headers)
}
